import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import JwtService from './jwtService'

function describeError(error) {
  const { response } = error

  if (error.code === 'ECONNABORTED' || (response && response.status === 504)) {
    return 'The request timed out. Try a smaller date range or try again later.'
  }
  if (!response) {
    return 'Network error. Please check your connection and try again.'
  }
  if (response.status >= 500) {
    return 'A server error occurred. Please try again.'
  }
  return (response.data && response.data.detail) || 'The request failed. Please try again.'
}

export default function useJwt(axiosIns, jwtOverrideConfig) {
  const jwt = new JwtService(axiosIns, jwtOverrideConfig)

  // Global fallback: notify the user about any request failure that
  // wasn't already handled (e.g. the silent 401 refresh-and-retry above).
  axiosIns.interceptors.response.use(
    response => response,
    error => {
      const status = error.response && error.response.status
      if (status !== 401 && !(error.config && error.config.skipGlobalErrorToast)) {
        Vue.prototype.$toast({
          component: ToastificationContent,
          props: {
            title: describeError(error),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        }, { timeout: 10000 })
      }
      return Promise.reject(error)
    },
  )

  return {
    jwt,
  }
}
